// AdicionarAoCarrinhoBtn.js — Botão de "Adicionar Ao Carrinho"
// Visual conforme mockup: pill outline laranja sobre fundo escuro.
import React, { useContext } from "react";
import { CarrinhoContext } from "../../services/context/CarrinhoContext";
import { useModal } from "../../services/context/ModalContext";

const AdicionarAoCarrinhoBtn = ({
  ebook,
  slider,
  onAddToCartSlider,
  btnText = "Adicionar Ao Carrinho",
  alt = false,
  newBtn = false,
  onBeforeAdd = () => true,
}) => {
  const { adicionarItem } = useContext(CarrinhoContext);
  const { openModal } = useModal();

  // Reduz o livro a um payload compatível com o carrinho
  const { id, titulo, preco, image, formato, quantidade } = ebook;
  const item = {
    id, titulo, preco, image, formato,
    quantidade: quantidade || 1,
  };
  if (ebook.frete) item.frete = ebook.frete;

  const handleAddToCart = () => {
    if (!onBeforeAdd()) return;
    adicionarItem(item);
    if (slider) onAddToCartSlider?.(item);
    openModal(item);
  };

  // Outline laranja (padrão dos cards)
  const base =
    "block w-full mt-2 px-5 py-2.5 rounded-full font-semibold text-sm md:text-base " +
    "text-insigne-orange border-2 border-insigne-orange bg-transparent " +
    "transition-all duration-300 hover:bg-insigne-orange hover:text-paper";

  // Alt: laranja sólido (usado em CTAs principais)
  const altCls = "!bg-insigne-orange !text-paper hover:!bg-insigne-orange-dark";

  // newBtn: layout retangular cheio (página de produto)
  const newCls =
    "block w-full px-4 py-4 rounded text-base font-bold uppercase text-paper " +
    "bg-insigne-orange border border-[#FAB908] transition-all duration-300 hover:bg-insigne-orange-dark";

  const className = newBtn ? newCls : `${base} ${alt ? altCls : ""}`;

  return (
    <button className={className} onClick={handleAddToCart}>
      {btnText}
    </button>
  );
};

export default AdicionarAoCarrinhoBtn;
